import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'

const StyledComponent = styled(({css, is_admin, ...rest}) => <div {...rest} />)`
    ${p => p.is_admin && css`

     background: radial-gradient(at right top, #1c5869, #133c4b);
     margin-bottom: 2px;
`}

  ${p => p.css};
`

const _PageHeader_InnerOuterStyles = (props) => <StyledComponent {...props} />
_PageHeader_InnerOuterStyles.propTypes = {
  css: PropTypes.string,
}

export default _PageHeader_InnerOuterStyles

